import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { InvoiceDetailPanel } from 'modules/finance/components/InvoiceDetailPanel'
import { useDelete } from 'modules/finance/hooks/useInvoices'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const InvoiceDetailPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { invoiceId } = useParams()
  const { company } = useCurrentSession()
  const { delete: destroy } = useDelete()

  const onClose = () => {
    navigate(navigation.finance.invoices.list.fullPath())
  }

  const onDelete = async () => {
    if (!invoiceId) return

    const result = await destroy({ id: Number(invoiceId), companyId: company.id })

    const handled = handleResult(result, () =>
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    )
    if (!handled.success) return handled

    app.setFlash({
      type: 'correct',
      message: i18n.t('finance.invoices.detail.sucess_deleted'),
    })
    onClose()
  }

  const oldPath = navigation.finance.invoices.list.invoiceId.reconciliations.fullPath({
    invoiceId: String(invoiceId),
  })
  const newPath = navigation.finance.spending.invoices.list.invoiceId.reconciliations.fullPath({
    invoiceId: String(invoiceId),
  })
  const hideInvoiceDetailPanel =
    window.location.pathname.includes(oldPath) || window.location.pathname.includes(newPath)

  const showInvoiceDetailPanel = invoiceId !== undefined && !hideInvoiceDetailPanel

  return (
    <ResponsivePage.Body variant="full" error={false} loading={false}>
      <Outlet />
      {showInvoiceDetailPanel && (
        <InvoiceDetailPanel invoiceId={Number(invoiceId)} onClose={onClose} onDelete={onDelete} />
      )}
    </ResponsivePage.Body>
  )
}

export default InvoiceDetailPage
